import { render, staticRenderFns } from "./TestimonialCarousel.vue?vue&type=template&id=7a391fe4&"
import script from "./TestimonialCarousel.vue?vue&type=script&lang=js&"
export * from "./TestimonialCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports